import styled from 'styled-components'

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 20px;

  > div {
    flex: 1;
  }
`

export const MappingContainer = styled.div`
  background: #f1f1f1;
  padding: 8px;
  border-radius: 4px;
`

export const MappingWrapper = styled.div`
  margin-top: 16px;
  position: relative;

  > svg {
    top: 30px !important;
    right: -4px !important;
  }
`
